<template>
  <div class="container">
    <div>
      <nav-bar title="检测报告"></nav-bar>
    </div>
    <div class="content">
      <img class="report_img" :src="reportPicUrl" alt="" v-if="reportPicUrl" />
      <iframe v-if="h5ReportUrl" :src="h5ReportUrl" frameborder="0" width="100%" height="100%" style="height:100%" leftmargin="0" topmargin="0"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tradeId: '',
      reportPicUrl: '',
      h5ReportUrl: ''
    }
  },
  mounted() {
    if (this.$route.query.tradeId) {
      this.tradeId = this.$route.query.tradeId
    }
    this.getCertifyReport()
  },
  methods: {
    async getCertifyReport() {
      // const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/certifyReport?tradeId=' + this.tradeId)
      // if (data.data.reportDetail.kind == 0) {
      //   this.reportPicUrl = data.data.reportDetail.reportPicUrl
      // } else if (data.data.reportDetail.kind == 1) {
      //   this.h5ReportUrl = data.data.reportDetail.h5ReportUrl
      // }

      //九江
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/certifyReport?tradeId=' + this.tradeId)
      if (data.data.reportDetail.pcReportUrl) {
        this.reportPicUrl = data.data.reportDetail.pcReportUrl
      } else {
        this.reportPicUrl = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
.content {
  .report_img {
    width: 100%;
    object-fit: cover;
  }
  width: 100%;
  height: 100%;
}
</style>
